<div class="add-food-bottomsheet-container">
  <div class="add-food-bottomsheet-top" (swipedown)="swipe($event.type)">
    <div class="add-food-bottomsheet-top-indicator"></div>
  </div>
  <div
    class="add-food-bottomsheet-name"
    id="add-food-name"
    *ngIf="!addPackage"
    [ngClass]="{ addTomeal: selectMeal }"
  >
    {{ data.food.name }}
  </div>
  <div
    class="add-food-bottomsheet-name add-package-title"
    id="add-food-name"
    *ngIf="addPackage"
  >
    افزودن پکیج
  </div>

  <!-- <div
    *ngIf="!calorie"
    class="add-food-bottomsheet-calorie"
    id="add-food-calorie"
  >
    ۰ کالری
  </div> -->
  <div *ngIf="!selectMeal && !addPackage">
    <div
      *ngIf="convertStringToNumber(amount) && gram === -1"
      class="add-food-bottomsheet-calorie"
      id="add-food-calorie"
    >
      {{ calorie.toFixed(0) }} کالری
    </div>
    <div
      *ngIf="convertStringToNumber(amount) && gram !== -1"
      class="add-food-bottomsheet-calorie"
      id="add-food-calorie"
    >
      {{ calorie.toFixed(0) }} کالری ({{ gram.toFixed(0) }} گرم)
    </div>

    <div class="add-food-bottomsheet-input-holder">
      <input
        type="text"
        inputmode="decimal"
        [(ngModel)]="amount"
        maxlength="5"
        (input)="calculateCalorie()"
        placeholder="مقدار"
      />
      <!-- <img src="assets/plan/down-arrow-blue.svg"> -->
      <mat-select
        class="add-food-bottomsheet-select"
        [(ngModel)]="selectedRatio"
        name="ratio"
        (selectionChange)="onRatioChange()"
      >
        <mat-option
          class="add-food-bottomsheet-option"
          *ngFor="let ratio of ratios"
          [value]="ratio"
        >
          {{ ratio }}
        </mat-option>
      </mat-select>
    </div>
    <mat-spinner *ngIf="showLoading" class="spinner"></mat-spinner>
    <div *ngIf="showLoading" class="spinner-holder"></div>

    <div class="buttons">
      <div
        *ngIf="!showLoading"
        [ngClass]="
          isButtonActive
            ? 'add-food-bottomsheet-submit submit-active'
            : 'add-food-bottomsheet-submit submit-disable'
        "
        (click)="addFood()"
        id="add-button"
      >
        ثبت
      </div>
      <div
        class="close-btn"
        (click)="close()"
        *ngIf="!isEditPeronalPackageEdit"
      >
        بستن
      </div>
      <div
        class="close-btn"
        (click)="remove()"
        *ngIf="isEditPeronalPackageEdit"
      >
        حذف
      </div>
    </div>
  </div>
  <div *ngIf="selectMeal">
    <div>
      <div class="meal">
        <img src="assets/plan/breakfast.png" alt="" />
        <p>صبحانه</p>
        <input
          [(ngModel)]="selectedMeal[0]"
          name="breakfast"
          type="checkbox"
          id="breakfast"
          (change)="onChangemealSelect($event)"
        />
      </div>
      <div class="meal">
        <img src="assets/plan/snack.png" alt="" />

        <p>میان‌وعده اول</p>
        <input
          [(ngModel)]="selectedMeal[1]"
          name="snack1"
          type="checkbox"
          id="snack1"
          (change)="onChangemealSelect($event)"
        />
      </div>
      <div class="meal">
        <img src="assets/plan/lunch.png" alt="" />

        <p>ناهار</p>
        <input
          [(ngModel)]="selectedMeal[2]"
          name="lunch"
          type="checkbox"
          id="lunch"
          (change)="onChangemealSelect($event)"
        />
      </div>
      <div class="meal">
        <img src="assets/plan/snack.png" alt="" />

        <p>میان‌وعده دوم</p>
        <input
          [(ngModel)]="selectedMeal[3]"
          name="snack2"
          type="checkbox"
          id="snack2"
          (change)="onChangemealSelect($event)"
        />
      </div>
      <div class="meal">
        <img src="assets/plan/dinner.png" alt="" />
        <p>شام</p>
        <input
          [(ngModel)]="selectedMeal[4]"
          name="dinner"
          type="checkbox"
          id="dinner"
          (change)="onChangemealSelect($event)"
        />
      </div>
      <div class="meal">
        <img src="assets/plan/snack.png" alt="" />
        <p>میان‌وعده سوم</p>
        <input
          [(ngModel)]="selectedMeal[5]"
          name="snack3"
          type="checkbox"
          id="snack3"
          (change)="onChangemealSelect($event)"
        />
      </div>
    </div>
    <div
      class="add-button"
      [ngClass]="{ blue: activeMeal && !foodCliked }"
      (click)="AddpersonalFood()"
    >
      <div class="">
        <img src="assets/plan/plus-white.svg" alt="" />
        <p>افزودن غذای شخصی</p>
      </div>
    </div>
  </div>
  <div *ngIf="addPackage">
    <p class="add-package-main">
      ایا پکیج {{ data.package.title }} به {{ meal }} اضافه شود؟
    </p>
    <div class="buttons">
      <div
        *ngIf="!showLoading"
        class="add-food-bottomsheet-submit"
        [ngClass]="{
          'submit-active': !packageClicked
        }"
        (click)="addingPackage()"
      >
        ثبت
      </div>
      <div class="close-btn" (click)="close()">بستن</div>
    </div>
  </div>
</div>
